import { FaGithub } from "react-icons/fa6";
import { RiTwitterXFill } from "react-icons/ri";
import { FaFacebookF, FaLinkedinIn } from "react-icons/fa";

const SocialIcon = () => {
  return (
    <div className="lg:block md:block hidden">
      <ul className="absolute top-[25%] xl:right-1 right-3 flex flex-col items-center ">
        <li className="text-lg mb-5 cursor-pointer z-40 bg-transparent hover:bg-gray-700 text-gray-400 hover:text-white h-8 w-8 flex justify-center items-center rounded-full transition-all duration-300 ease-in-out">
          <a href="https://github.com/Ashraful2880" target="blank">
            <FaGithub />
          </a>
        </li>
        <li className="text-lg mb-5 cursor-pointer z-40 bg-transparent hover:bg-blue-700 text-gray-400 hover:text-white h-8 w-8 flex justify-center items-center rounded-full transition-all duration-300 ease-in-out">
          <a href="https://www.facebook.com/ashraful2880" target="blank">
            <FaFacebookF />
          </a>
        </li>
        <li className="text-lg mb-5 cursor-pointer z-40 bg-transparent hover:bg-[#0077b5] text-gray-400 hover:text-white h-8 w-8 flex justify-center items-center rounded-full transition-all duration-300 ease-in-out">
          <a href="https://www.linkedin.com/in/islam-ashraful1/" target="blank">
            <FaLinkedinIn />
          </a>
        </li>
        <li className="text-lg mb-10 cursor-pointer z-40 bg-transparent hover:bg-[#00ACEE] text-gray-400 hover:text-white h-8 w-8 flex justify-center items-center rounded-full transition-all duration-300 ease-in-out">
          <a href="https://x.com/IslamAshraful80" target="blank">
            <RiTwitterXFill />
          </a>
        </li>
        <h4 className="text-[20px] leading-[30px] text-gray-400 xl:flex justify-end items-center -rotate-90 social_title mt-10 font-semibold hidden">
          {/* I am Here */}
        </h4>
      </ul>
    </div>
  );
};

export default SocialIcon;
